import moment from "moment";
import modelBaseV2 from "../model-base-v2.model";
import { formats } from "../../config/constants";

const IMEISerialSalesCheckingModel = {
    getExcelTemplate: (dataType) => {
        const fileName = `Template${dataType === "IMEI" ? "IMEI" : "SerialNumber"}List`
        const exportConfig = {
            storedProcedureCode: dataType === "IMEI" ? "39" : "40",
            params: [],
            excelSheetNames: ["Sheet1", "Sheet2", "Sheet3"]
        };
        return modelBaseV2.postDownload("/api/executesp/export/file", { body: exportConfig }, fileName);
    },
    uploadIMEISerialList: (dataType, file) => {
        let body = new FormData();
        body.append('data', file);
        const params = { dataType }

        return modelBaseV2.post('/api/imei-reports/imei-serial-sales-checking/:dataType', { body, params });
    },
    downloadIMEISerialUploadResult: (fileId, fileName = 'Result') => {
        modelBaseV2.getDownload('/api/file/temp/:fileId', { params: { fileId } }, `${fileName}_${moment().format(formats.apiDateFormat)}`)
    }
}
export default IMEISerialSalesCheckingModel